export default __webpack_public_path__ + "static/media/Bhushan.05d0fa1e.jpeg";